<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-single-radio
				[threeCols]="true"
				formControlName="type"
				[label]="'shared|type-label'"
				[selectOptions]="options()" />
		</div>
	</form>
</app-section-wrapper-container>
